import { createContext } from 'react';
import useIsAdmin from 'src/hooks/useIsAdmin';

const defaultAuthProviderState = {
  loading: true,
  user: undefined,
  isAdmin: false,
  isLoggedIn: false,
};

const AuthContext = createContext(defaultAuthProviderState);

const AuthProvider = ({ children }) => {
  const ctx = useIsAdmin();
  return <AuthContext.Provider value={ctx}>{children}</AuthContext.Provider>;
};

export default AuthContext;
export { defaultAuthProviderState, AuthProvider, AuthContext };
